import React from 'react'

const Ekchihan = () => {
  return (
    <div>
        <div>
<h3>शब्दभण्डार</h3>
      <h5>१. शब्द र अर्थका बिचमा जोडा मिलाउनुहोस् :</h5>
      <p><strong>रुजु: </strong>कुनै कुरा ठिक छ कि छैन भनी जाँच्ने काम</p>
      <p><strong>कविराज: </strong>आयुर्वेदिक उपचार गर्ने चिकित्सकको एक उपाधि</p>
      <p><strong>पेस्की: </strong>काम पूरा हुनु पहिले दिइने रकम</p>
      <p><strong>तल्सिङ: </strong>मोहीलाई जग्गा कमाउन दिने व्यक्ति, जग्गाधनी</p>
      <p><strong>समवेदना: </strong> उस्तै दु:खको अनुभव</p>
      <p><strong>निर्दयी: </strong>दया नभएको</p>
      <p><strong>अकर्मण्य: </strong>केही पनि काम नगर्ने, निस्क्रिय</p>
      <p><strong>मुराद: </strong>भित्री आशय</p>
      <p><strong>सान्त्वना: </strong>आश्वासन, ढाडस</p>
      <p><strong>हथुङ्गा: </strong>हातको नाडीदेखि औंलाका टुप्पासम्मको भाग</p>
      <p><strong>दागबत्ती: </strong>शवका मुखमा राख्ने बत्ती</p>
      <p><strong>कृतज्ञता: </strong>अरूले गरेको गुनप्रति धन्यवाद दिने भाव</p>
        </div>
        <hr/>
      <div>
        <h5>२. पाठमा प्रयोग भएका दिइएका शब्दको अर्थ पहिचान गरी लेख्नुहोस् :</h5>
        <p><strong>गुभाजु: </strong>बिरामीहरूलाई झारफुक गर्ने नेवार समुदायको तान्त्रिक व्यक्ति</p>
        <p><strong>उघाड: </strong>सीमा नाघेर भन्नु</p>
        <p><strong>फोने: </strong>विना मागमा आफैँ दिन खोज्नु</p>
        <p><strong>माचाछी: </strong>जोईपोइ बच्चाबच्चीको एकसरो परिवार मात्र</p>
        <p><strong>नङ्के: </strong>कहिल्यै प्राप्त वा अनुभव नभएको कुरा पाउनु</p>
        <p><strong>बिचा: </strong>क्रियापुत्रीलाई बन्धुवर्गका तर्फबाट दिइने सिधा</p>
        <p><strong>डल्लेठो: </strong>डल्ला फोर्ने काठको हतियार</p>
        <p><strong>खर्पन: </strong>काठमाडौँमा प्रचलित मालसमान बोक्ने साधन</p>
        <p><strong>क्वेना: </strong>बाँध, किनार, कुना, नदीको भुमरी पर्ने किनारको खोच</p>
      </div>
      <hr/>
      <div>
        <h5>३. दिइएका शब्दको उस्तै अर्थ दिने शब्द पहिचान गरी लेख्नुहोस् :</h5>
        <p><strong>दीक्षा: </strong>मन्त्रोपदेश</p>
        <p><strong>सितिमिति: </strong>	हत्तपत्त</p>
        <p><strong>उपचार: </strong>इलाज</p>
        <p><strong>पेटपालो:</strong>गुजारा</p>
        <p><strong>मृत्यु: </strong>निधन</p>
        <p><strong>बोली: </strong>वाणी</p>
        <p><strong>मौन: </strong>चुप</p>
        <p><strong>तत्क्षण: </strong>तत्काल</p>
        <p><strong>फजिती: </strong>मुस्किल</p>
        <p><strong>सावगास: </strong>शक्ति</p>
      </div>
      <hr/>
      <div>
        <h5>४. दिइएका अनेकार्थक शब्दलाई फरक फरक अर्थ दिने गरी वाक्यमा प्रयोग गर्नुहोस् :</h5>
        <strong>उत्तर</strong>
        <p>परीक्षामा सबै प्रश्नको उत्तर सही ढंगले लेखेँ ।</p>
        <p>हामी उत्तर तर्फ यात्रा गर्दै थियौं, जहाँ हिमाल देखिन्थ्यो ।</p>
        <strong>खरी</strong>
        <p>बुबाले खेतबाट मल ल्याउन खरी प्रयोग गर्नुभयो ।</p>
        <p>उसको लुगामा धुवाँको खरी ले दाग परेको थियो ।</p>
        <strong>गोल</strong>
        <p>उसले कागजमा गोल आकृति बनाए ।</p>
        <p>सन्दीपले अन्तिम समयमा गोल हानेर टिमलाई जिताए ।</p>
        <strong>जग</strong>
        <p>हजुरआमाले ढोकामा जगमा पानी राख्नुभयो ।</p>
        <p>सद्भावनामा जग नरहेको सम्बन्ध टिक्दैन ।</p>
        <strong>तान</strong>
        <p>उसले ढोका खोल्न बल गरेर तान दियो ।</p>
        <p>गायकले मीठो तान लगाएर गीत गाए ।</p>
        <strong>तर</strong>
        <p>ऊ पढाइमा त राम्रै छ, तर उसले ध्यान कम दिन्छ ।</p>
        <p>उनले खोला तर गरेर गन्तव्यमा पुगे ।</p>
        <strong>पत्र</strong>
        <p>उसले विदेशमा बसेका दाजुलाई माया मिसिएको पत्र लेखी ।</p>
        <p>बरको रुखको हरियो पत्र हावामा फर्फरायो ।</p>
        <strong>पत्र</strong>
        <p>उसले विदेशमा बसेका दाजुलाई माया मिसिएको पत्र लेखी ।</p>
        <p>बरको रुखको हरियो पत्र हावामा फर्फरायो ।</p>
        <strong>वर</strong>
        <p>उनको विवाहमा राम जी उत्कृष्ट वर थिए।</p>
        <p>यो पुस्तक मेरो हातमा परेको सबैभन्दा वर कृति हो।</p>
        <strong>बाली</strong>
        <p>यस वर्ष धानको बाली राम्रो भयो।</p>
        <p>उनको मेहनतको बाली अहिले फलिरहेको छ।</p>
        <strong>रहर</strong>
        <p>उनीले विदेश जाने ठूलो रहर पालिन्।</p>
        <p>बच्चाहरूले गुरुजीको कुरा रहर गरेर सबैलाई हँसाए।</p>
        <strong>साँचो</strong>
        <p>तिमीले जे भन्यौ त्यो साँचो हो।</p>
        <p>म ताला खोल्नका लागि साँचो खोज्दैछु।</p>
        <strong>सुर</strong>
        <p>उहाँले गीतमा निकै मीठो सुर पस्कनुभयो।</p>
        <p>हामीले घरको सुर लागि कडा व्यवस्था गर्नुपर्छ।</p>
        <strong>हार</strong>
        <p>उनले खेलमा हार स्वीकार गरिन्।</p>
        <p>उनले श्रीमतीलाई सुनको राम्रै हार किनिदिए।</p>
        <strong>जाली</strong>
        <p>उसले झ्यालमा फलामको जाली लगायो।</p>
        <p>पुलिसले नक्कली नोट छाप्ने जाली समूहलाई पक्रियो।</p>
      </div>
      <hr/>
      <div>
        <h5>५. दिइएका शब्दको श्रुतिसमभिन्नार्थक शब्द लेख्नुहोस् :</h5>
        <p><strong>दिन: </strong>दीन</p>
        <p><strong>दिशा: </strong>दिसा</p>
        <p><strong>शव: </strong>सब</p>
        <p><strong>बाँस: </strong>बास</p>
        <p><strong>व्यसन: </strong>बेसन</p>
        <p><strong>प्रदान: </strong>प्रधान</p>
        <p><strong>कोस: </strong>कोश</p>
        <p><strong>जाति: </strong>जाती</p>
        <p><strong>फेरि: </strong>फेरी</p>
        <p><strong>खालि: </strong>खाली</p>
        <p><strong>पाश: </strong>पास</p>
         <p><strong>गर्भ: </strong>गर्व</p>
          <p><strong>विष: </strong>बिस</p>
           <p><strong>आदि: </strong>आदी</p>
            <p><strong>पाइन्: </strong>पाइन</p>
             <p><strong>ताप: </strong>टाप</p>
              <p><strong>देखि: </strong>देखी</p>
               <p><strong>सिता: </strong>सीता</p>
      </div>
      <hr/>
      <div>
        <h5>६. दिइएका शब्दको समूहवाचक शब्द लेख्नुहोस् :</h5>
        <p><strong>कमिला: </strong>ताँती</p>
        <p><strong>गाईवस्तु: </strong>बथान</p>
        <p><strong>मौरी: </strong>गोलो</p>
        <p><strong>बारुला: </strong>गोलो</p>
        <p><strong>बाँस: </strong>घारी</p>
        <p><strong>दाउरा: </strong>खलियो</p>
        <p><strong>डोरी: </strong>माला</p>
        <p><strong>मानिस: </strong>जमात</p>
        <p><strong>मकै: </strong>थाङ्ग्रो</p>
        <p><strong>भेडा: </strong>बथान</p>
        <p><strong>पराल: </strong>टौवा</p>
        <p><strong>पर्वत: </strong>श्रेणी</p>
        <p><strong>सिपाही: </strong>फौज</p>
        <p><strong>धुवाँ: </strong>मुस्लो</p>
      </div>
      <hr/>
      <div>
        <h5>७. शिक्षकसँग सोधेर दिइएका प्रतीकात्मक शब्दको अर्थ लेख्नुहोस् :</h5>
        <p><strong>छेपारो: </strong>रङ बदल्ने, अवसर अनुसार रूप फेरिने व्यक्ति</p>
        <p><strong>कुवेर: </strong>अत्यन्त धनी व्यक्ति</p>
        <p><strong>रामराज्य: </strong>सम्पन्न, सुखी र न्यायपूर्ण शासन</p>
        <p><strong>दुर्वासा: </strong>छिटो रिसाउने, क्रोधित स्वभावको व्यक्ति</p>
        <p><strong>दधिची: </strong>त्यागी व्यक्ति</p>
        <p><strong>सुदामा: </strong>गरिब, निर्धन तर मित्रवत व्यक्ति</p>
        <p><strong>भीष्म: </strong>भयानक, दृढ वा कठिन निर्णय लिने व्यक्ति</p>
        <p><strong>बाँदर: </strong>आफू पनि बिगार्ने र अरूलाई पनि बिगार्न दिने</p>
        <p><strong>साँढे: </strong>मिचाहा, दम्भी र निरंकुश व्यक्ति</p>
        <p><strong>जुको: </strong>परजीवी, अरूको भरमा बाँच्छने</p>
        <p><strong>सावित्री: </strong>पतिव्रता, नारी आदर्शको प्रतीक</p>
        <p><strong>गङ्गा: </strong>पवित्रता र धार्मिकता</p>
        <p><strong>स्याल: </strong>चालाक, बाठो</p>
        <p><strong>ब्वाँसो: </strong>धूर्त, चालबाज</p>
        <p><strong>आकाश: </strong>विशाल, रित्तो, अनन्त</p>
        <p><strong>एकलव्य: </strong>लगनशील, गुरुभक्त र एक्लो योद्धा</p>
        <p><strong>मौरी: </strong>परिश्रमी, मेहनती</p>
        <p><strong>लक्ष्मण रेखा: </strong>सीमा, मर्यादा</p>
        <p><strong>महाभारत: </strong>ठूलो लडाइँ, झगडा</p>
        <p><strong>कर्ण: </strong>दानी, उदार</p>
        <p><strong>भेडो: </strong>मूर्ख, पछि लाग्ने मात्र</p>
        <p><strong>कुम्भकर्ण: </strong>सुताहा, धेरै सुत्ने व्यक्ति</p>
        <p><strong>भगीरथ: </strong>कठिन प्रयास गर्ने व्यक्ति</p>
        <p><strong>विदुर: </strong>ज्ञानी, विवेकी</p>
        <p><strong>युधिष्ठिर: </strong>	धर्मात्मा, सत्यवादी वा अजेय व्यक्ति</p>
        <p><strong>शकुनि: </strong>कपटी, षडयन्त्रकारी</p>
        <p><strong>नारद: </strong>कुरौटे, हल्ला फैलाउने</p>
     
      </div>
      <hr/>
      <div>
        <h5>८. कक्षामा छलफल गरी दिइएका सिङ्गो शब्दको अर्थ लेख्नुहोस् :</h5>
        <p> <strong>शाकाहारी - </strong> सात्विक भोजन मात्र गर्ने वा माछामासु नखाने</p>
        <p><strong>मांसाहारी - </strong> माछामासु खाने</p>
        <p><strong>पुङमाङ - </strong>दुवैपट्टि खुला भएको ढुङ्ग्रो</p>
        <p><strong>गृहस्थी - </strong>घरबार गरेर बस्ने व्यक्ति</p>
        <p><strong>अल्लारे - </strong>आलोकाँचो अवस्थाको</p>
        <p><strong>पेवा - </strong>निजी</p>
        <p><strong>शक -</strong>द दश वर्षको अवधि</p>
        <p><strong>शताब्दी -</strong> सय वर्षको समय</p>
        <p><strong>सहस्राब्दी - </strong>एक हजार वर्ष</p>
        <p><strong>शाश्वत -</strong> सधैं रहिरहने, चिरस्थायी</p>
        <p><strong>वात्सल्य - </strong>आमाबाबुको सन्तानप्रतिको स्नेह</p>
        <p><strong>न्वाँगी - </strong>नयाँ धानबाली पाकेपछि देवता वा पितृलाई चढाई खाइने दही चामल</p>
        <p><strong>नाबालक -</strong> बालिग हुने उमेर नपुगेको बालक</p>
        <p><strong>लैनो - </strong>भर्खर बियाएको</p>
        <p><strong>बकेर्नो -</strong> दुध थाक्ने बेला भएको दुहुनो</p>
        <p>सत्पात्र  असल व्यक्ति वा पात्र</p>
        <p><strong>आद्योपान्त - </strong>सुरुदेखि अन्त्यसम्म</p>
        <p><strong>क्षितिज -</strong> पृथ्वी र आकाश जोडिएजस्तो देखिने</p>
        <p><strong>उपवास -</strong> केही नखाई व्रत बस्ने काम</p>
        <p><strong>सर्वभक्षी - </strong>भोज्य र अभोज्य विचार नगरी सबै कुरा खाने</p>
        <p><strong>ढडिया -</strong> माछा समात्ने सोलीजस्तो पासो</p>
        <p><strong>अभेद्य -</strong> प्वाल पार्न नसकिने</p>
        <p><strong>कटुभाषी - </strong>नमिठो बोल्ने</p>
        <p><strong>अल्पभाषी - </strong>थोरै भाषा जान्ने</p>
        <p><strong>मृदुभाषी - </strong>मिठो भाषा बोल्ने</p>
        <p><strong>बहुभाषी - </strong>धेरै भाषा बोल्ने</p>
        <p><strong>बहुरूपी - </strong>धेरै रूप धारण गर्ने</p>
        <p><strong>अघोरी -</strong> जे पायो त्यही खाने</p>
        <p><strong>कायममुकायम -</strong> कार्यबाहक</p>
        <p><strong>कार्यवाहक - </strong>कुनै व्यक्तिको अनुपस्थितिमा नियमानुसार अधिकार लिई अस्थायी रूपमा काम गर्ने कर्मचारी</p>
        <p><strong>पर्म - </strong>आलोपालो गरी एकले अर्काको काम गरिदिने चलन</p>
        <p><strong>अवर्णनीय - </strong>वर्णन गर्न नसकिने</p>
        <p><strong>अव्यक्त - </strong>अव्यक्त - प्रकट नभएको</p>
        <p><strong>थाती - </strong>धरौटी जमानत</p>
        <p><strong>कलस्यौली -</strong> विवाहमा कलश बोकेर जन्तीमा हिँड्ने कन्या अलौकिक, यस लोकमा नहुने वा नपाइने</p>
      </div>
      <hr/>
      <div>
        <h5>९. अन्तरिक्षसँग सम्बन्धित तलका शब्दलाई शब्दकोशीय अनुक्रममा मिलाई लेख्नुहोस् र तिनको अर्थ पनि पत्ता लगाउनुहोस् :</h5>
        <p>उल्का: पुञ्ज, धूमकेतु, आकाशबाट खस्ने ज्वलन्त आकाशीय पिण्ड</p>
        <p>ज्ञेय: जान्न लायक, बुझ्न मिल्ने कुरा</p>
        <p>ग्रह: सूर्यको वरिपरि परिक्रमा गर्ने आकाशीय पिण्डहरू (जस्तै पृथ्वी, मङ्गल आदि)</p>
        <p>नक्षत्र: 	तारा, सितारा, मोती, ज्योतिषमा प्रयोग हुने स्थिर ताराहरूको समूह</p>
        <p>तारापुञ्ज: आकाशमा देखिने ताराहरूको समुदाय; तारामण्डल </p>
        <p>धूमकेतु: पुच्छ्रेतारा, टाउको जस्तो भाग र पछाडि लामो पुच्छर हुने, कहिलेकाहीं देखिने</p>
        <p>ब्रह्माण्ड: सम्पूर्ण अन्तरिक्ष, ग्रह, तारा, नक्षत्र, आकाशगङ्गा, आदि समेटिएको विश्व</p>
        <p>राशि: क्रान्तिवृत्तमा रहेका १२ भागहरू: मेष, वृष, मिथुन आदि ज्योतिषीय चिन्हहरू</p>
        <p>सौर्यमण्डल: सूर्य र यसको वरिपरि घुम्ने ग्रहहरूको समूह (जस्तै: पृथ्वी, बृहस्पति, शनि आदि)</p>
      </div>
      <div>
        <hr/>
        <h3>बोध र अभिव्यक्ति</h3>
        <h5>१. ‘एक चिहान’ उपन्यासको पहिलो परिच्छेद पढ्नुहोस् र दिइएका प्रश्नको उत्तर भन्नुहोस् :</h5>
        <h5>(क) अष्टनारानले श्रीमती, छोराहरू र छोरीलाई के भनेर सम्झाउँछन् ?</h5>
        <p>= अष्टनारानले आफ्ना छोराहरू र छोरीलाई जन्म त दिएँ, तर गाँस–बासको कुनै व्यवस्था मिलाउन सकिनँ भनी सम्झाउँछन्। उनी भन्छन् कि सधैंभरि पूजा गरे तापनि भगवान्ले केही सुनिदिएनन्। साथै, उनले श्रीमतीलाई आमा र बहिनीलाई जस्तोसुकै दुःख परे पनि हेला नगर्न भनी सम्झाउँछन्।</p>
        <h5>(ख) अष्टनारानले आफ्नो काजकिरियाका लागि कस्तो बन्दोबस्त मिलाएका छन्?</h5>
        <p>= अष्टनारानले बिस्तारै गरेर पच्चीस रुपियाँ जम्मा गरेका थिए र ती रुपियाँ छिँडीको ढिकीनेर खाल्टो खनेर गाडेर राखेका थिए, ताकि आफ्नै काजकिरियाका लागि केही बन्दोबस्त मिलोस्।</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका बुँदालाई समेटेर ‘एक चिहान’ उपन्यासको परिच्छेद दुई र तीनको सार लेख्नुहोस् :</h5>
        <p>= अष्टनारान दुई महिनादेखि गम्भीर रूपमा बिरामी पर्न थालेका हुन्छन्। परिवारले उपचारका लागि विभिन्न प्रयास गर्छन्। सुरुमा आफ्नै टोलका गुभाजुबाट एक महिना, असनका तुयु गुभाजुबाट एक्काइस दिन, र माहिला कविराजबाट एक हप्ता उपचार गराउँछन्, तर कुनै सिप लाग्दैन। बिरामीको अवस्था झन् गम्भीर बन्दै जान्छ।
</p><p>
गाउँमा डाक्टर त थिए तर उनीहरूसँग उपचार गराउने आर्थिक साधन थिएन। त्यसैले अष्टनारानकै काजकिरियाका लागि राखिएको पच्चीस रुपियाँ निकालेर उपचारका लागि प्रयोग गर्ने निर्णय गरिन्छ। शिवनारान डाक्टर गोदत्तप्रसादकहाँ जान्छन्, तर डाक्टर उनको आग्रहलाई महत्त्व दिंदैनन्। पछि पुननारान पनि अनुरोध गर्न जान्छन्, तर डाक्टर अझै अनिच्छुक देखिन्छन्। अन्ततः घरमा पुग्नासाथ पाँच रुपियाँ फी दिने कबोल गरेपछि मात्र डाक्टर अष्टनारानकहाँ जान तयार हुन्छन्।</p>
      </div>
      <hr/>
      <div>
        <h5>३. तलको उपन्यास अंश पढी दिइएका प्रश्नको उत्तर लेख्नुहोस् :</h5>
        <h5>(क) प्रेम हुन केही गाह्रो छैन भन्नुको तात्पर्य के हो?</h5>
        <p>= यो भनाइको तात्पर्य हो कि प्रेम प्राकृतिक भावना हो, जसलाई संस्कृति, भाषा, जात, दूरी, वा परिस्थितिले रोक्न सक्दैन। जब दुई व्यक्तिको मन मिल्छ, समझदारी हुन्छ, र साँचो भावना उत्पन्न हुन्छ, त्यतिबेला प्रेम स्वतः उत्पन्न हुन्छ। त्यसैले प्रेम गर्न कुनै ठूलो प्रयास, योजना वा सर्त आवश्यक पर्दैन भन्ने भाव यस कथनमा व्यक्त गरिएको छ।</p>
        <h5>(ख) दिइएको उपन्यास अंशमा प्रेमका सम्बन्धमा कसरी व्याख्या गरिएको छ ?</h5>
        <p>= प्रेम हुन गाह्रो छैन र यो तुरुन्तै पनि हुन सक्छ । प्रेमले संस्कृति, भाषा, जाति, टाढानजिक, सुखदुःख जस्ता केही कुरा पनि हेर्दैन । दिलसँग दिल मिलेपछि तुरुन्त प्रेम हुन्छ । प्रेमका विषयमा उपन्यासकारको भनाई अल्लारे र भावुक प्रेम गर्नु हुँदैन, आत्मीय प्रेम गर्नुपर्छ र अल्लारे र भावुक प्रेमले दुःख दिन्छ भन्नु छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>४. अष्टनारानले मर्ने वेलामा आफ्ना छोरालाई किसानको सिद्धान्तका बारेमा बताएका छन् । उनले बताएका किसानका सिद्धान्त के के हुन्, उपन्यासको छैटौँ परिच्छेद पढी उत्तर लेख्नुहोस् ।</h5>
        <p>= अष्टनारानले मर्ने बेलामा आफ्ना छोरालाई किसानका केही महत्वपूर्ण सिद्धान्तहरू बताए। उनका अनुसार किसानहरू संसारका अन्नदाता हुन् र उनीहरूको रगत र पसिनाबाट अन्न उत्पादन हुन्छ। संसारको अस्तित्व किसानको परिश्रममा निर्भर हुन्छ। किसानको धर्म भनेको परिश्रम गर्नु हो। किसानले असारको पूजा छाडेर बाबुको किरिया गर्दा खेतबारी बिग्रिन्छ भने त्यसको असर पूरै वर्षभरि पर्न सक्छ। त्यसैले उनले भने, किसानले कहिल्यै अल्छी गर्नु हुँदैन र सधैं कृषि कर्ममा तल्लीन रहनुपर्छ।</p>
      </div>
      <hr/>
      <div>
        <h5>५. मरेपछि गरिने काजक्रिया र दानदक्षिणासम्बन्धी अष्टनारानको विचारसँग तपाईंको सहमति वा विमति के छ, तर्कसहित लेख्नुहोस् ।</h5>
        <p>= म अष्टनारानको विचारसँग पूर्ण रूपमा सहमत छु। उपन्यास ‘एक चिहान’ का प्रमुख पात्र अष्टनारानले परम्परागत समाजमा जरा गाडेर बसेका कुसंस्कारहरूप्रति प्रगतिशील दृष्टिकोण राखेका छन्। उनी मरेपछि गरिने धूमधामका काजक्रिया, अनावश्यक भोजभतेर, र दानदक्षिणालाई अर्थहीन ठान्छन्। यस्तो परम्पराले खासगरी आर्थिक रूपमा कमजोर परिवारहरूलाई झन गरिब बनाउने काम गर्छ।</p>
        <p>अष्टनारानले समाजमा जरा गाडेर बसेका यस्ता कुप्रथाविरुद्ध आवाज उठाउनु मात्र होइन, आफू मरेपछि पनि यस्ता परम्परा नअपनाउन अन्तिम इच्छासमेत व्यक्त गर्छन्। उनका छोराले पनि बाबुको विचारलाई अनुसरण गरेर क्रियापूजा नगरी सिधा असारको खेती गर्न जानु क्रान्तिकारी कदम हो।</p>
        <p>हाम्रो नेपाली समाज परम्परा र संस्कृतिमा धनी छ, तर त्यही परम्पराको नाममा अन्धविश्वास र आर्थिक शोषण बढाउने चालचलन स्वीकार्य हुँदैनन्। त्यसैले हामीले अष्टनारानजस्तै विवेकशील भएर यस्ता परम्पराहरूको पुनरावलोकन गर्नुपर्छ। आवश्यक र सामाजिक रूपमा उपयोगी परम्परा मात्र पालना गर्नु आजको समाजको आवश्यकता हो।</p>
      </div>
      <hr/>
      <div>
        <h5>६. ‘एक चिहान’ उपन्यासमा नेपाली समाजको कस्तो अवस्थाको चित्रण गरिएको छ, वर्णन गर्नुहोस् ।</h5>
        <p>= ‘एक चिहान’ हृदयचन्द्र सिंह प्रधानद्वारा लिखित एक सामाजिक यथार्थवादी उपन्यास हो। यस उपन्यासमा २०११ साल तिरको काठमाडौंको समाजलाई चित्रण गरिएको छ, जहाँ समाज धनी र गरिब गरी दुई वर्गमा विभाजित छ।</p>
        <p>धनी वर्गका मानिसहरू शिक्षा, स्वास्थ्य र सुविधामा पहुँच भएका छन्, तर तिनले गरिबलाई देखावटी सहयोग गरेजस्तो गरे पनि त्यसको पछाडि स्वार्थ लुकेको देखिन्छ। विपन्न वर्ग भने अत्यन्तै दयनिय अवस्थामा छन् किसान, सिकर्मी, मजदुरहरूले धेरै मेहनत गरे पनि पेट पाल्न कठिन हुन्छ।</p>
        <p>उपन्यासले जातीय विभेद, आर्थिक असमानता, अन्धविश्वास, धार्मिक आडम्बर, रुढीवादी सोच, आदि कुसंस्कारहरूको आलोचना गरेको छ। अष्टनारानजस्ता पात्रहरूमार्फत सामाजिक जागरण र चेतनाको लहर फैलिएको देखाइन्छ। काजक्रिया, दानदक्षिणा, भोजभतेर जस्ता खर्चिलो परम्पराले गरिब जनतालाई अझै गरिब बनाएको यथार्थ चित्रण गरिएको छ।</p>
        <p>सुब्बा सुरमान र डाक्टर गोदत्तप्रसाद जस्ता पात्रहरू मार्फत शोषक वर्ग को दोहोरो चरित्र उजागर गरिएको छ। उपन्यासले यस्ता विकृति हटाएर समानता, न्याय र परिवर्तनमुखी समाज निर्माण गर्न आग्रह गर्दछ।</p>
      </div>
      <hr/>
      <div>
        <h5>७. ‘एक चिहान’ उपन्यासका आधारमा दिइएका पात्रको चरित्र चित्रण गर्नुहोस् :</h5>
        <h5>(क) शिवनारान</h5>
        <p>= शिवनारान ‘एक चिहान’ उपन्यासको प्रमुख पुरुष पात्र हुन्। उनी अष्टनारानका जेठा छोरा तथा उपन्यासका नायक हुन्। उनले उपन्यासभरि किसान वर्गको प्रतिनिधित्व गरेका छन्। उनी इमानदार, परिश्रमी, विवेकी, आज्ञाकारी, कर्मशील, र न्यायप्रेमी पात्र हुन्।</p>
        <p>शिवनारानमा प्रगतिशील विचार पाइन्छ। उनले समाजमा जरा गाडेर बसेका कुसंस्कार र अन्धविश्वासको विरोध गर्छन् र बाबु अष्टनारानको विचारबाट प्रभावित भई क्रियाकर्मको साटो असारको खेतीलाई प्राथमिकता दिन्छन्।</p>
        <p>उनले आफ्नो परिवारप्रति उत्तरदायी, असल पति, असल दाजु, असल अभिभावकको भूमिका निर्वाह गरेका छन्। उनी गाउँमा हुने अन्यायको प्रतिकार गर्न तयार रहने सचेत र सक्रिय किसानको प्रतीक हुन्।</p>
        <p>यसरी, शिवनारान उपन्यासका प्रगतिशील सोच बोकेको, मेहनती किसानको जीवन्त उदाहरण हुन् जसले सामाजिक परिवर्तनका लागि सशक्त सन्देश दिन्छन्।</p>
        <h5>(ख) रञ्जनादेवी</h5>
        <p>= रञ्जनादेवी उपन्यासकी सहायक स्त्री पात्र हुन्। उनी प्रोफेसरकी छोरी र डाक्टरकी श्रीमती हुन्। उनी एक शिक्षित, सचेत र प्रगतिशील नारीको प्रतीक हुन्। रञ्जनादेवीले स्वार्थी प्रेमको विरोध गर्छिन् र नारी–पुरुषबीच समन्वय र सहकार्य हुनु आवश्यक भन्ने आदर्श चिन्तन राख्छिन्।</p>
        <p>उनको व्यक्तित्वले उपन्यासमा सकारात्मक सोच र आधुनिकताको परिचय दिन्छ। रञ्जनादेवी नारी सशक्तिकरणको प्रतिमूर्तिका रूपमा प्रस्तुत भएकी छन्।</p>
        <h5>(ग) नानीथकुँ</h5>
        <p>= नानीथकुँ ‘एक चिहान’ उपन्यासको प्रमुख नारी पात्र हुन्। उनी अष्टनारानकी छोरी र शिवनारानकी बहिनी हुन्। उनको अनुहार गोरो छ र १७ वर्षकी युवती भएकी कारण उनी सुन्दरी मानिन्छिन्। उनी सरल, निश्चल र निर्दोष स्वभावकी छिन्।</p>
        <p>तर, उनी डाक्टर गोदत्तप्रसादको बलात्कारको शिकार भएकी छन् र यस कारण उनी कुमारीत्वबाट वञ्चित भएकी छिन्। नानीथकुँ सकारात्मक सोच राख्ने पात्र हुन् र उनले तराईबासी खेलावन राउतसँग अन्तरजातीय विवाह गर्छिन्, जुन उपन्यासमा सामाजिक बाधा र पूर्वाग्रहलाई चुनौती दिन्छ।</p>
      </div>
      <hr/>
      <div>
        <h5>८. डाक्टर गोदत्तप्रसाद र सुरमान सुब्बाका चरित्रमा पाइने समानता के के हुन् एक चिहान’ उपन्यासका आधारमा लेख्नुहोस् ।</h5>
        <p>= डाक्टर गोदत्तप्रसाद र सुरमान सुब्बा ‘एक चिहान’ उपन्यासका प्रमुख नकारात्मक पात्र हुन्। दुवै उच्च वर्गीय, प्रतिष्ठित र परिवारसहितका व्यक्तिहरू भए पनि उनीहरूको स्वभाव धूर्त, स्वार्थी र निर्दयी छ। उनीहरू मानवता र नैतिकताबाट टाढा भएर आफ्नो स्वार्थ पूर्ति गर्न कुनै पनि हदसम्म जाने गर्दछन्। दुवैले नानीथकुँको जवानी र सौन्दर्यमा ध्यान दिँदै उनलाई आफ्नो स्वार्थका लागि प्रयोग गर्ने कोशिस गर्छन्। यी दुबै पात्रले उपन्यासमा समाजका शोषक र रुढीवादी प्रवृत्तिको प्रतिनिधित्व गर्छन् र सामाजिक न्याय र समानताका लागि आवश्यक चेतनालाई चुनौती दिन्छन्। यसरी, डाक्टर गोदत्तप्रसाद र सुरमान सुब्बाका चरित्रहरूमा निडर स्वार्थ, निर्दयता र मानवता अभावको समानता पाइन्छ।</p>
      </div>
      <hr/>
      <div>
        <h5>९. ‘एक चिहान’ उपन्यासमा हर्षनारान र पुतली तथा नानीथकुँ र रामखेलावन राउतका बिचको विवाहबाट उपन्यासले के सन्देश दिन खोजेको छ, स्पष्ट पार्नुहोस् ।</h5>
        <p>= ‘एक चिहान’ उपन्यासमा हर्षनारान र पुतली तथा नानीथकुँ र रामखेलावन राउतका बिचको विवाहले गहिरो सामाजिक सन्देश दिन खोजेको छ। उपन्यासले विवाहलाई दुई आत्माको मेल र सम्बन्ध स्थापनाको आधारका रूपमा प्रस्तुत गरेको छ र विवाहमा दाइजो, भोज भतेर, र फजुल खर्च जस्ता अनावश्यक परम्पराले गरिब परिवारलाई आर्थिक भारमा पार्ने कुरालाई स्पष्ट रूपमा आलोचना गरेको छ। अष्टनारान र उनका सन्तानहरूले दाइजो र भतेरविना विवाह गरेर यो कुसंस्कारलाई चुनौती दिएका छन्। यसले समाजमा चलेको दाइजो प्रथा र फजुल खर्चको विरोध मात्र नभई क्रान्तिकारी कदम पनि हो।</p>
        <p>हर्षनारान र पुतली तथा नानीथकुँ र रामखेलावन राउतको अन्तरजातीय विवाहले जातीय, क्षेत्रीय भेदभावलाई टुङ्ग्याएर समाजमा एकता र मेलमिलापको सन्देश दिएको छ। यसले नेपालको विविध जाति र समुदायहरूबीचको भाइचारालाई बलियो बनाउन र अखण्ड नेपाल, समृद्ध नेपाल निर्माणमा योगदान पुर्‍याउनुपर्ने आवश्यकतालाई जोड दिएको छ।</p>
        <p>मैले यस सन्देशलाई पूर्ण समर्थन गर्दछु, किनभने अनावश्यक विवाह खर्चले गरिब परिवारलाई थप ऋणको बोझ दिन्छ र यसले घरेलु हिंसा र सामाजिक समस्याहरू पनि जन्माउन सक्छ। विवाहमा मानिसहरूको आत्मीयता, माया र सद्भाव नै महत्वपूर्ण हुन्छ, न कि धन खर्च र भव्य भोज। त्यसैले उपन्यासले यस्तो व्यवहारलाई परिमार्जन गरी सकारात्मक सामाजिक परिवर्तनको आवश्यकता औँल्याएको छ।</p>
      </div>
      <hr/>
      <div>
        <h5>१०. ‘एक चिहान’ उपन्यासको अन्त्य तपाईंलाई ठिक वा बेठिक कस्तो लाग्यो ? यदि तपाईं त्यसको लेखक हुनुभएको भए यसलाई कसरी अन्त्य गर्नुहुन्थ्यो, आफ्नो विचार लेख्नुहोस् ।</h5>
        <p>= 'एक चिहान' उपन्यासको अन्त्य मलाई उपयुक्त र प्रभावकारी लाग्यो। हृदयचन्द्र सिंह प्रधानले निम्नवर्गीय जीवनका कष्ट, संघर्ष र पीडालाई मार्मिक तरिकाले प्रस्तुत गर्दै सामाजिक यथार्थवादलाई दृढताका साथ उभ्याएका छन्। उपन्यासको शीर्षक जस्तै अन्त्यले पनि मृत्युसँग जोडिएको यथार्थलाई झल्काउँछ र गरिबी, अन्याय, र सामाजिक विसंगतिहरूको निरन्तरता देखाउँछ। यसले पाठकलाई सोच्न बाध्य पार्ने प्रभाव छोड्छ।</p>
        <p>यदि म लेखक भएको भए, म उपन्यासको अन्त्यमा शिवनारान र उनका परिवारका साथसाथै अर्को कुनै सकारात्मक पात्रको पनि उपस्थित गराउने थिएँ जसले गरिबी र अन्यायविरुद्ध उठेको सामाजिक चेतनाको झल्को दिने थियो। यसरी म समाजिक परिवर्तन र आशाको संकेत दिने खालको अन्त्य थप्थें, जसले पाठकलाई निराश होइन, परिवर्तनका लागि प्रेरित गर्नेछ। तर समग्रमा, यस किसिमको यथार्थपरक र प्रगतिशील अन्त्य नै उपन्यासको मर्मलाई सबैभन्दा प्रभावकारी रूपमा व्यक्त गर्दछ।</p>
      </div>
      <hr/>
      <div>
        <h5>१२. दिइएको उपन्यास अंशमा आएका पात्रको चरित्रचित्रण गर्नुहोस् :</h5>
        <h5>शिवनारानको चरित्रचित्रण</h5>
        <p>= शिवनारान अष्टनारानका जेठो छोरा हुन् र ‘एक चिहान’ उपन्यासका प्रमुख पुरुष पात्र हुन्। उनी किसान वर्गको जीवन र संघर्षको सजीव प्रतिनिधित्व गर्छन्। शिवनारान अन्यायको दृढ विरोधी हुन् र आफ्नो इमानदारी, आज्ञापालन, मेहनत, विवेकशीलता, कर्मठता र जागरुकताका कारण समाजमा सकारात्मक प्रभाव पार्छन्। उनी आफ्नो परिवारप्रति जिम्मेवार, समाजप्रति सचेत र सुधारका पक्षमा क्रियाशील पात्र हुन्।</p>
        <h5>रामबहादुरको चरित्रचित्रण</h5>
        <p>= एक चिहान’ उपन्यासमा रामबहादुर नकारात्मक खलपात्रको रूपमा प्रस्तुत गरिएको छ। उनी सुब्बा सुरमानका भरोसायोग्य कारिन्दा हुन् र सुरमानको योजना अनुसार शिवनारानको घरमा नानीथकुँलाई फसाउन आएका छन्। रामबहादुरलाई कसलाई कसरी छल्ने र मक्क गर्ने थाहा छ, त्यसैले उनी शिवनारानसँग सिधा कुरा नगरी घुमाएर र छलपछल गरेर संवाद गर्छन्। उनी असमान विवाहको विरोध गर्ने खलपात्र हुन् र गरिब जनतालाई फकाउने र ठग्ने कलामा निपुण छन्। तर शिवनारानको चतुरताले उनको योजना असफल हुन्छ। योजना असफल भएपछि उनी शिवनारानलाई धम्क्याउने र डराउने प्रयास गर्छन्।</p>
      </div>
      <hr/>
      <div>
        <h5>१४. दिइएको अनुच्छेद पढी सोधिएका प्रश्नको उत्तर लेख्नुहोस् :</h5>
        <h5>(क) “उस्तरी बस्ती थिएन” भन्नुको तात्पर्य के हो ?</h5>
        <p>= “उस्तरी बस्ती थिएन” भन्नुको तात्पर्य हो त्यो ठाउँमा मानिसहरूको बसोबास कम मात्रामा वा विरलै भएको थियो अर्थात् त्यहाँ घरहरू घना रूपमा थिएनन् र मानिसहरू थोरै मात्र बस्दै आएका थिए।</p>
        <h5>(ख) सम्साँझमै स्याल कराउनका लागि कुन कुराले सहयोग गरेको थियो ?</h5>
        <p>= साँझमै स्याल कराउनका लागि तितेपातीका घारी र खरीका रुखले सहयोग गरेको थियो।</p>
        <h5>(ग) कसरी कोटेश्वर आधुनिक जङ्गलमा बदलियो ?</h5>
        <p>= मानिसका घारी, आधुनिक भवनहरू, बिजुलीका पोल र तारका कारणले कोटेश्वर आधुनिक जङ्गलमा बदलियो ।</p>
        <h5>(घ) अहिलेको कोटेश्वरमा कस्ता मानिस बस्छन् ?</h5>
        <p>= अहिलेको कोटेश्वरमा नेता, कार्यकर्ता, व्यापारी, सुरक्षाकर्मी, न्यायकर्ता, साहु–महाजन, उद्योगी, चोर–फटाहा सबै किसिमका मानिसहरू बसोबास गर्छन्।</p>
      </div>
      <div>
        <hr/>
        <h3>व्याकरण</h3>
        <h5>२. ‘खेल्, हिँड्, खा, बस्, घुम्, नाच्’ जस्ता धातुबाट बनेका भूतकालिक क्रियापदको प्रयोग गरी शैक्षिक भ्रमणबारे एक अनुच्छेद लेख्नुहोस् ।</h5>
        <p>= हाम्रो विद्यालयले गत हप्ता एक शैक्षिक भ्रमणको आयोजना गर्‍यो। हामी सबै विद्यार्थीहरू बिहानै स्कूलमा जम्मा भयौं र समयमै बस चढ्‍यौं। शिक्षकको निर्देशनअनुसार हामीले अनुशासनमा बस्‍यौं र रमाइलो गर्न तयार भयौं। बाटोभरि हामी गीत गाउँदै नाच्यौं, रमाइलो गर्‍यौं र रमाइला कुरा गर्दै घुम्यौं। जब हामी गन्तव्यस्थलमा पुग्यौं, सबैले खाना खायौं र रमाइलो खेल खेल्यौं। यस भ्रमणले हामीलाई धेरै नयाँ कुरा सिक्‍न र साथीहरूसँग सहकार्य गर्न सहयोग गर्‍यो। अन्ततः हामी सबै थकित भए पनि खुशी हुँदै फर्कियौं। यसरी, यो शैक्षिक भ्रमण एउटा अविस्मरणीय अनुभव बन्‍यो।</p>
      </div>
      <hr/>
      <div>
        <h5>३. भूत कालका अभ्यस्त पक्षका क्रियापदको प्रयोग गरी आफ्नो बाल्यकालका बारेमा वर्णन गर्नुहोस् ।</h5>
        <p>= म बाल्यकालमा गाउँमै बस्ने गर्थें। बिहान चाँडै उठ्ने बानी थियो र आमासँगै गाई दुहाउने गर्थें। साथीहरूसँग खोलामा पौडी खेल्ने र रूखमा चढ्ने गर्दथेँ। हरेक साँझ घर फर्केपछि हजुरआमासँग पुराना कथाहरू सुन्ने गर्थें। स्कूल जानु अगाडि आमाले खाजा बनाएर दिनुहुन्थ्यो, म त्यो खाजा झोलामा राखेर जान्थें। छुट्टीपछि साथीहरूसँग ढुंगाको खेल खेल्ने गर्थें। यस्तो रमाइलो जीवन बिताउने बानी मेरो बाल्यकालभरि थियो। ती दिनहरू सम्झँदा आज पनि मन खुसीले भरिन्छ।</p>
      </div>
      <hr/>
      <div>
        <h5>४. भविष्यत् कालका अपूर्ण तथा पूर्ण पक्षको प्रयोग गरी आफ्नो भविष्यको योजनाबारे लेख्नुहोस् ।</h5>
        <p>= म भविष्यमा एक सफल व्यक्ति बन्ने लक्ष्य राख्दछु। म पढाइमा अझ मेहनत गर्नेछु र नयाँ सीपहरू सिक्दै जानेछु। म आगामी वर्षमा स्नातक तहको पढाइ पूरा गरिरहेको हुनेछु। त्यसपछि म विदेश जाने योजना बनाउनेछु र त्यहाँ उच्च शिक्षा लिनेछु। म सूचना प्रविधि क्षेत्रमा काम गर्नेछु र आफ्नै स्टार्टअप सुरु गरिसकेको हुनेछु। भविष्यमा म समाजका लागि उपयोगी कामहरू गर्नेछु र गरिब तथा असहायको सहयोग गर्नेछु। म आफ्ना सपना पूरा गर्न निरन्तर प्रयास गरिरहेको हुनेछु र एक दिन लक्ष्य हासिल गरिसकेको हुनेछु।</p>
      </div>
      <hr/>
      <div>
        <h5>५. दिइएको अनुच्छेदलाई वर्तमान कालको अपूर्ण पक्षमा परिवर्तन गरी लेख्नुहोस् :
      </h5>
         <p>= शिवनारान आज साबिक झैँ समयमै खेतमा जाँदै छन् । आजैदेखि उनले नानीथकुँलाई पनि खेतमा लैजान सुरु गर्दै छन् । रोपाइँ सकिएकाले खेतको सुरक्षाका लागि आजदेखि खेतमा खाने र सुत्ने अर्थात् रातदिन खेतैमा बस्ने बन्दोबस्त पनि शिवनारानले गर्दै छन् । खास गरेर शिवनारानको कोठाको एक परिवार खेतैमा बस्न थाल्दै छ । नानीथकुँ र पुननारानकी स्वास्नी अनि उनका दुई केटाकेटीसहित दिनभरि खेतमा काम गरी साँझमा फर्कदै छन् ।</p>
      </div>
      <hr/>
      <div>
        <h5>६. दिइएको अनुच्छेदलाई भूत कालको अज्ञात पक्षमा परिवर्तन गरी लेख्नुहोस् :</h5>
        <p>= डाक्टर गोदत्तप्रसादले आफू विवाहित र छोराछोरीको बाबु हुँ भन्ने पनि बिर्सिएछन् । उनी नानीथकुँका घरमा धाउन थालेछन् । उनीहरू एकान्तमा भेट्ने र कुराकानी गर्न थालेछन् । त्यो कुरा थाहा पाएर शिवनारानले नानीथकुँलाई सम्झाएछन् । डाक्टर गोदत्तप्रसादकी पत्नी रञ्जनादेवीले पनि सम्झाइछन्। अन्त्यमा नानीथकुँले पनि कुरा बुझिछन् । नानीथकुँ र गोदत्तप्रसादका बिचमा सम्बन्ध टुटेछ । एक दिन नानीथकुँको रामखेलावन राउतसँग भेट भएछ । रामखेलावन र नानीथकुँका बिचमा प्रेम भएछ । त्यो कुरा शिवनारानले विचार गरिराखेछन् उनले नानीथकुँको बिहे रामखेलावनसँग गराइदिएछन् । आफूले रोजेको मान्छेसँग बिहे गर्न पाएर दुवै जना खुसी भएछन् ।</p>
      </div>
      <hr/>
      <div>
        <h5>७. शिरबिन्दु तथा चन्द्रबिन्दुको प्रयोग भएका तलका शब्दलाई वर्णानुक्रमअनुसार लेख्नुहोस् :</h5>
        <p>अँगार, अँध्यारो, अंश, भयौँ, वंश, सँग, संयम, संरक्षण, संलग्न, संवाद, संशय, संसार, संहार</p>
      </div>
      <hr/>
      <div>
        <h5>८. दिइएका शब्दलाई तालिकामा देखाउनुहोस् :</h5>
        <strong>क, ख, ग, घ अघि ‘ङ्’</strong>
        <p>अङ्क, शङ्कर, शङ्ख, पङ्खा, ढङ्ग, मङ्गल, बङ्गुर, गङ्गा, चङ्गा, सङ्घ</p>
        <strong>च, छ, ज, झ अघि (तत्सम शब्दमा मात्र) ‘ञ्’</strong>
        <p>अञ्चल, पञ्च, पुञ्ज, लाञ्छना, ब्यञ्जन, झञ्झा, मञ्जुल</p>
        <strong>ट, ठ, ड, ढ अघि (तत्सम शब्दमा मात्र) ‘ण्’</strong>
        <p>पण्डित, कण्ठ, कुण्ठा, दण्ड, खण्ड, खण्डन</p>
        <strong>त, थ, द ध अघि ‘न्’</strong>
        <p>सन्त, बन्धन, भिन्न, मन्तब्य, परन्तु पन्थ, बन्दी, खिन्न</p>
        <strong>प, फ ब भ अघि ‘म्’</strong>
        <p>कम्प, पम्फा, अम्बा, लम्ब, स्तम्भ, जम्मा</p>
        <strong>य, र, ल, व, श, ष, स, ह, ज्ञ अघि (तत्सम शब्द) शिरबिन्दु</strong>
        <p>सयम, संशय, संसार संहार, संरक्षण, संलग्न, संवाद, वंश संज्ञा संज्ञान, संवाद संवत्</p>
      </div>
    </div>
  )
}

export default Ekchihan
